import { useContext } from "react";
import { EnquiryFormContext } from "./EnquiryForm";

export const useEnquireForm = () => useContext(EnquiryFormContext);

export default useEnquireForm;
